/** @jsx h */
const Loading = () => (
  <div class="loading">
    <div class="loading__inner">
      <svg class="loading__circular" aria-hidden="true" viewBox="25 25 50 50">
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" class="stop-color-light" />
            <stop offset="100%" class="stop-color-dark" />
          </linearGradient>
        </defs>
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke="url(#gradient)"
          stroke-width="2"
          stroke-miterlimit="10"
          transform="rotate(90 50 50)"
        />
      </svg>
    </div>
  </div>
);

export default Loading;
